module.exports = __webpack_public_path__ + "static/media/auth-bg.3f9259f6.jpg";